// Timestamps are stored and sent as UTC ('Z'); the browser shows them, and reads filter values,
// in the time zone of the machine it runs on.

const dateTimeFormat = new Intl.DateTimeFormat('en-GB', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hourCycle: 'h23',
});

const dateTimeFormatNoSeconds = new Intl.DateTimeFormat('en-GB', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23',
});

// e.g. "27/10/2026, 12:00:00" in the browser's time zone
export const formatDateTime = (value?: string | Date | null, withSeconds = true): string => {
    if (!value) return '';
    const date = value instanceof Date ? value : new Date(value);
    if (isNaN(date.getTime())) return '';
    return (withSeconds ? dateTimeFormat : dateTimeFormatNoSeconds).format(date);
};

// For UTC values the API sends without an offset, e.g. profile event times ("2026-10-27 10:00").
export const parseUtc = (value?: string | null): Date | null => {
    if (!value) return null;
    const date = new Date(value.trim().replace(' ', 'T') + 'Z');
    return isNaN(date.getTime()) ? null : date;
};

// Filter value for the API: the time picked in the date picker (browser time zone), as UTC with 'Z'.
// "to" values cover the whole selected minute.
export const toApiDateTime = (value: string | Date | null | undefined, endOfMinute = false): string | undefined => {
    if (!value) return undefined;
    const d = value instanceof Date ? new Date(value) : new Date(value);
    if (isNaN(d.getTime())) return undefined;
    d.setSeconds(endOfMinute ? 59 : 0, endOfMinute ? 999 : 0);
    return d.toISOString();
};

// Picker defaults: "from" starts at 00:00 and "to" ends at 23:59 of the given day.
export const startOfDay = (value: Date): Date => {
    const d = new Date(value);
    d.setHours(0, 0, 0, 0);
    return d;
};

export const endOfDay = (value: Date): Date => {
    const d = new Date(value);
    d.setHours(23, 59, 0, 0);
    return d;
};
